import { Release } from "shared-ts-release";
import { Typography } from "@mui/material";
import ignition_quality from "./ignition_quality.png";

export const release_2026_1_0: Release = {
  version: "2026.1.0",
  date: "2026-01-15",
  entries: [
    {
      type: "Feature",
      heading: "Oversiktssiden gir deg nå Opptenninger etter kvalitet",
      description: (
        <>
          <Typography>
            Få oversikt over hvordan innbyggerne får til opptenninger.
          </Typography>
          <img
            src={ignition_quality}
            alt={"ignition_quality"}
            width={"100%"}
            style={{ marginTop: "1em", marginBottom: "0.5em" }}
          />
        </>
      ),
    },
    {
      type: "Improvement",
      heading: "Bedre beregninger av fyringer og sot",
      description: (
        <>
          <Typography>
            Beregninger av fyringer og sot tar nå høyde for 'lav-temperatur-sone' og vedilegg.
          </Typography>
        </>
      ),
    },
    {
      type: "Improvement",
      heading: "Fargetema",
      description: (
        <>
          <Typography>
            Vi jobbet med fargetema for å livne opp uttrykket litt.
          </Typography>
        </>
      ),
    },
    {
      type: "Usability",
      heading: "Generelle forbedringer",
      description: (
        <>
          <Typography>
            Vi har jobbet med å forbedre brukeropplevelsen av eksisterende komponenter.
            Flere av skjermbildene er nå linket sammen og jobber på tvers slik at man kan klikke og 'drille' seg inn i data, f.eks via grafer.
          </Typography>
        </>
      ),
    },
    {
      type: "Bugfix",
      heading: "Kabelbrudd",
      description: (
        <>
          <Typography>
            Vi har endret på hvordan en sensor blir oppdaget og klassifisert som 'Kabelbrudd'.
          </Typography>
        </>
      ),
    },
  ],
};
